module.exports = __webpack_public_path__ + "static/june-3-985bac467c225f031711123393964828.png";